import { googleInstance } from "../utils/axios";

export const placeSearch = (params) => {
  return googleInstance.get('__google-proxy/maps/api/place/autocomplete/json', { params });
};

export const placeDetails = (params) => {
  return googleInstance.get('__google-proxy/maps/api/geocode/json', { params });
};